import { Navigate, Outlet, useLocation } from 'react-router';
import { useAppSelector } from '@/app/hooks';
import { PATHS } from '@/app/paths';

export function AuthGuard() {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate to={PATHS.login} replace state={{ from: location.pathname + location.search }} />
    );
  }
  return <Outlet />;
}

export function GuestGuard() {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const location = useLocation();

  if (isAuthenticated) return <Navigate to={getReturnTo(location.state)} replace />;
  return <Outlet />;
}

function getReturnTo(state: unknown): string {
  const from = (state as { from?: unknown } | null)?.from;

  return typeof from === 'string' && from.startsWith('/') && !from.startsWith('//')
    ? from
    : PATHS.dashboard;
}
